import React from 'react';
import { Box, Typography } from '@mui/material';
import { CalendarToday } from '@mui/icons-material';

interface UploadDateProps {
  uploadDateFormatted: string;
}

/**
 * Displays upload date with calendar icon.
 */
export const UploadDate: React.FC<UploadDateProps> = ({ uploadDateFormatted }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 0.5 }}>
    <CalendarToday sx={{ fontSize: 14, color: '#64748b' }} />
    <Typography variant="body2" sx={{ fontSize: '0.875rem' }}>
      {uploadDateFormatted}
    </Typography>
  </Box>
);

/** Syncfusion grid template wrapper */
export const uploadDateTemplate = (props: { uploadDateFormatted: string }) => (
  <UploadDate uploadDateFormatted={props.uploadDateFormatted} />
);

export default UploadDate;
